import { render, staticRenderFns } from "./ImportExportFromTo.vue?vue&type=template&id=61a1702e"
import script from "./ImportExportFromTo.vue?vue&type=script&lang=js"
export * from "./ImportExportFromTo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports